import * as actionTypes from './actionTypes';
import createAction from '@/Framework/State/Redux/createAction';

export const setPageFilters = (payload) => createAction(actionTypes.SET_PAGE_FILTERS, payload);

export const resetPageFilters = () => createAction(actionTypes.RESET_PAGE_FILTERS);
